import { chunk, flatten, isEmpty, map } from 'lodash-es'
import { DataItem } from 'scrivito'

import { getDataItemsPromise } from './getDataItemsPromise'
import { getReferencedIds } from './getReferencedIds'
import { getLocalizedSchemaAttributes } from './schemaLocalization'
import { DataClassName } from '@/Data/const'
import { SchemaAttributes } from '@/Data/types'
import { DataItemReferenceAdd } from '@/hooks/useDataItemReferenceHandler'

export const getReferencedDataItems = async ({
  rawValue,
  key,
  schema,
  add,
}: {
  rawValue: unknown
  key: string
  schema: DataItem
  add?: DataItemReferenceAdd
}) => {
  const ids = getReferencedIds(rawValue)
  const attribute = getLocalizedSchemaAttributes(
    schema?.get('attributes') as SchemaAttributes,
  )?.[key]
  const attributeType = attribute?.type
  const attributeReferenceTo = attribute?.referenceTo

  let dataClassName: string | undefined

  if (attributeType === 'reference') {
    dataClassName = attributeReferenceTo
  }

  if (attributeType === 'objectarray') {
    switch (key) {
      case 'contacts':
      case 'companies':
      case 'persons':
      default:
        // only contacts implemented so far
        dataClassName = DataClassName.CONTACT
        break
    }
  }

  if (!dataClassName) {
    return []
  }

  const chunkedIds = chunk(ids, 50)

  const promises = map(chunkedIds, (ids) => {
    return getDataItemsPromise(dataClassName, ids)
  })

  const referencedItems = flatten(await Promise.all(promises))

  if (add && !isEmpty(referencedItems)) {
    add(referencedItems)
  }

  return referencedItems
}
